module.exports = __webpack_public_path__ + "img/game_gchess_x.73e20f1.jpg";